// @ts-nocheck
import React, { useState } from 'react';
import { Settings, Package2, Scissors, FileText, Magnet, Calculator } from 'lucide-react';
import { SheetCuttingOptimizer } from '@/components/production/SheetCuttingOptimizer';
import { AdvancedMagnetCalculator } from '@/components/production/AdvancedMagnetCalculator';
import { ProductionQueue } from '@/components/production/ProductionQueue';
import { ProductionHistory } from '@/components/production/ProductionHistory';
import EngineeringPage from './EngineeringPage';

export const ProductionPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'optimizer' | 'queue' | 'history' | 'magnets' | 'engineering'>('optimizer');

  const tabs = [
    { id: 'engineering', label: 'Obliczenia inżynierskie', icon: Calculator },
    { id: 'optimizer', label: 'Optymalizator rozkroju', icon: Scissors },
    { id: 'magnets', label: 'Kalkulator magnesów', icon: Magnet },
    { id: 'queue', label: 'Kolejka produkcji', icon: Package2 },
    { id: 'history', label: 'Historia', icon: FileText }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900">
      <div className="space-y-6 p-6">
        {/* Nagłówek */}
        <div>
          <h1 className="text-2xl sm:text-3xl font-bold text-white flex items-center gap-2 sm:gap-3">
            <Settings className="w-6 h-6 sm:w-8 sm:h-8 text-orange-500" />
            Produkcja
          </h1>
          <p className="text-sm sm:text-base text-gray-400 mt-2">
            Zarządzaj procesem produkcji i optymalizuj wykorzystanie materiału
          </p>
        </div>

        {/* Zakładki */}
        <div className="bg-zinc-800/50 backdrop-blur-sm rounded-lg shadow-xl border border-zinc-700">
          <div className="border-b border-zinc-700 overflow-x-auto">
            <nav className="flex -mb-px min-w-fit">
              {tabs.map(tab => {
                const Icon = tab.icon;
                return (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id as any)}
                    className={`
                      flex items-center gap-1 sm:gap-2 px-3 sm:px-6 py-3 border-b-2 font-medium text-xs sm:text-sm transition-all whitespace-nowrap
                      ${activeTab === tab.id
                        ? tab.id === 'engineering' 
                          ? 'border-purple-500 text-purple-500 bg-purple-900/20'
                          : 'border-orange-500 text-orange-500 bg-zinc-700/50'
                        : 'border-transparent text-gray-400 hover:text-white hover:bg-zinc-700/30'
                      }
                    `}
                  >
                    <Icon className="w-4 h-4" />
                    {tab.label}
                  </button>
                );
              })}
            </nav>
          </div>

          {/* Zawartość zakładek */}
          <div className={activeTab === 'engineering' ? '' : 'p-4 sm:p-6'}>
            {activeTab === 'engineering' && (
              <div className="bg-transparent">
                <EngineeringPage embedded={true} />
              </div>
            )}

            {activeTab === 'optimizer' && (
              <div className="bg-gray-800/50 backdrop-blur-sm rounded-lg p-6">
                <div className="mb-6">
                  <h2 className="text-2xl font-semibold mb-2 text-white">Optymalizator rozkroju materiału</h2>
                  <p className="text-gray-400">
                    Zoptymalizuj wykorzystanie arkuszy pleksi i innych materiałów. 
                    System automatycznie układa elementy minimalizując odpad.
                  </p>
                </div>
                <SheetCuttingOptimizer />
              </div>
            )}

            {activeTab === 'queue' && (
              <div className="bg-gray-800/50 backdrop-blur-sm rounded-lg p-6">
                <div className="mb-6">
                  <h2 className="text-2xl font-semibold mb-2 text-white">Kolejka produkcji</h2>
                  <p className="text-gray-400">
                    Zarządzaj aktualnymi zleceniami produkcyjnymi. Śledź postęp, zmieniaj statusy i generuj kody QR.
                  </p>
                </div>
                <ProductionQueue />
              </div>
            )}

            {activeTab === 'magnets' && (
              <div className="bg-gray-800/50 backdrop-blur-sm rounded-lg p-6">
                <div className="mb-6">
                  <h2 className="text-2xl font-semibold mb-2 text-white">Zaawansowany kalkulator magnesów neodymowych</h2>
                  <p className="text-gray-400">
                    Profesjonalny kalkulator z rzeczywistymi danymi technicznymi, wizualizacją 3D i analizą wpływu temperatury.
                    System uwzględnia różne gatunki magnesów (N35-N52), warunki montażu i generuje dokumentację techniczną.
                  </p>
                </div>
                <AdvancedMagnetCalculator />
              </div>
            )}

            {activeTab === 'history' && (
              <div className="bg-gray-800/50 backdrop-blur-sm rounded-lg p-6">
                <div className="mb-6">
                  <h2 className="text-2xl font-semibold mb-2 text-white">Historia produkcji</h2>
                  <p className="text-gray-400">
                    Przeglądaj zrealizowane zlecenia, analizuj statystyki i eksportuj raporty.
                  </p>
                </div>
                <ProductionHistory />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};